import React from "react";
import { Button, ButtonsGroupContainer } from "./styles";

export interface IButtonsGroup {
  options: {
    label: string;
    value: string;
    icon?: React.FC<{ className?: string; selected?: boolean }>;
  }[];
  onChange: (value: string) => void;
  value: string;
  className?: string;
}

export const ButtonsGroup: React.FC<IButtonsGroup> = ({
  value,
  options,
  onChange,
  className
}) => {
  return (
    <ButtonsGroupContainer className={className}>
      {options.map((o) => {
        return (
          <Button
            key={o.value}
            selected={value === o.value}
            onClick={() => {
              onChange(o.value);
            }}
          >
            {o.icon
              ? React.createElement(o.icon, {
                  selected: value === o.value
                })
              : null}
            <span>{o.label}</span>
          </Button>
        );
      })}
    </ButtonsGroupContainer>
  );
};
